module.exports = __webpack_public_path__ + "static/media/ccs.d0d8dcca.png";